<template>
  <div class="px-3 pt-1">
    <v-layout wrap>
      <v-flex xs12 class="text-xs-right">
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 class="pb-3">
        <v-btn
          depressed
          :outline="currentTab != 'info'"
          :color="currentTab == 'info' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="currentTab = 'info'"
          >ข้อมูลทั่วไป</v-btn
        >
        <v-btn
          depressed
          :outline="currentTab != 'history'"
          :color="currentTab == 'history' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="currentTab = 'history'"
        >
          รายการเดินคะแนนสะสม
        </v-btn>
        <v-btn
          v-if="$store.state.privilege && $store.state.privilege.role == 'superadmin'"
          depressed
          :outline="currentTab != 'editLog'"
          :color="currentTab == 'editLog' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="currentTab = 'editLog'"
        >
          ประวัติการแก้ไข
        </v-btn>
      </v-flex>
    </v-layout>
    <template v-if="currentTab === 'info'">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm6 style="border-right: 1px solid #eee">
          <div style="position: relative">
            <v-btn
              style="z-index: 3; position: absolute; right: 0px; top: 0px"
              small
              @click="showImage(input.identityNumberImage)"
            >
              <v-icon>visibility</v-icon>
            </v-btn>

            <uploadfile v-model="input.identityNumberImage" :height="500"></uploadfile>
          </div>

          <template
            v-if="
              $store.state.privilege &&
              ['superadmin', 'admin'].includes($store.state.privilege.role)
            "
          >
            <v-btn
              depressed
              color="error"
              :disabled="!input.identityNumberImage"
              @click="input.identityNumberImage = ''"
            >
              <v-icon>delete</v-icon>
              <span class="pl-1">ลบรูปบัตรประชาชน</span>
            </v-btn>
          </template>
          <!-- <v-img
         
          contain
          height="500px"
          :src="editdata.identity_number_image"
        ></v-img> -->
        </v-flex>
        <v-flex xs12 sm6>
          <div class="px-4 pb-3">
            <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">แก้ไขข้อมูล</div>
            <div class="form-control">
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('memberId') }"
                >
                  <label>{{ $t('รหัสสมาชิก') }}</label>
                  <input
                    v-model="input.memberId"
                    readonly
                    :data-vv-as="$t('รหัสสมาชิก')"
                    class="form-control"
                    type="text"
                    name="memberId"
                  />
                  <span v-if="errors.has('memberId')" class="text-error">{{
                    errors.first('memberId')
                  }}</span>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('tier') }"
                >
                  <label>{{ $t('Tier') }}</label>
                  <input
                    v-model="input.tier"
                    readonly
                    :data-vv-as="$t('Tier')"
                    class="form-control"
                    type="text"
                    name="tier"
                  />
                  <span v-if="errors.has('tier')" class="text-error">{{
                    errors.first('tier')
                  }}</span>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('firstName') }"
                >
                  <label>{{ $t('ชื่อจริง') }}</label>
                  <input
                    v-model="input.firstName"
                    v-validate="'required'"
                    :data-vv-as="$t('ชื่อจริง')"
                    class="form-control"
                    type="text"
                    name="firstName"
                  />
                  <span v-if="errors.has('firstName')" class="text-error">{{
                    errors.first('firstName')
                  }}</span>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('lastName') }"
                >
                  <label>{{ $t('นามสกุล') }}</label>
                  <input
                    v-model="input.lastName"
                    v-validate="'required'"
                    :readonly="edittype == 'edit'"
                    :data-vv-as="$t('นามสกุล')"
                    class="form-control"
                    type="text"
                    name="lastName"
                  />
                  <span v-if="errors.has('lastName')" class="text-error">{{
                    errors.first('lastName')
                  }}</span>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('dob') }"
                >
                  <label>{{ $t('วันเดือนปี เกิด') }}</label>
                  <DatePickerWithoutButton v-model="input.dob">
                    <input
                      v-validate="'required'"
                      readonly
                      :data-vv-as="$t('วันเดือนปี เกิด')"
                      :value="getdate(input.dob)"
                      class="form-control"
                      type="text"
                      name="dob"
                    />
                  </DatePickerWithoutButton>
                  <span v-if="errors.has('dob')" class="text-error">{{ errors.first('dob') }}</span>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('job') }"
                >
                  <label>{{ $t('อาชีพ') }}</label>
                  <input
                    v-model="input.job"
                    v-validate="'required'"
                    :data-vv-as="$t('อาชีพ')"
                    class="form-control"
                    type="text"
                    name="job"
                  />

                  <span v-if="errors.has('job')" class="text-error">{{ errors.first('job') }}</span>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('identityNumber') }"
                >
                  <label>{{ $t('เลขบัตรประชาชน') }}</label>
                  <input
                    v-model="input.identityNumber"
                    v-validate="'required|thai_idcard'"
                    :readonly="
                      $store.state.privilege && $store.state.privilege.role !== 'superadmin'
                    "
                    :data-vv-as="$t('เลขบัตรประชาชน')"
                    class="form-control"
                    type="text"
                    name="identityNumber"
                  />
                  <span v-if="errors.has('identityNumber')" class="text-error">{{
                    errors.first('identityNumber')
                  }}</span>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('lineName') }"
                >
                  <label>{{ $t('ไลน์') }}</label>
                  <input
                    v-model="input.lineName"
                    v-validate="'required'"
                    readonly
                    :data-vv-as="$t('ไลน์')"
                    class="form-control"
                    type="text"
                    name="lineName"
                  />
                  <span v-if="errors.has('lineName')" class="text-error">{{
                    errors.first('lineName')
                  }}</span>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('departmentStore') }"
                >
                  <label>{{ $t('ห้าง') }}</label>
                  <input
                    v-model="input.departmentStore"
                    v-validate="'required'"
                    readonly
                    :data-vv-as="$t('ห้าง')"
                    class="form-control"
                    type="text"
                    name="departmentStore"
                  />
                  <span v-if="errors.has('departmentStore')" class="text-error">{{
                    errors.first('departmentStore')
                  }}</span>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('branch') }"
                >
                  <label>{{ $t('สาขา') }}</label>
                  <input
                    v-model="input.branch"
                    v-validate="'required'"
                    readonly
                    :data-vv-as="$t('สาขา')"
                    class="form-control"
                    type="text"
                    name="branch"
                  />
                  <span v-if="errors.has('branch')" class="text-error">{{
                    errors.first('branch')
                  }}</span>
                </v-flex>
                <v-flex xs12>
                  <div>
                    <v-checkbox
                      v-model="member_status"
                      :label="`Approve`"
                      color="primary"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn outline color="grey" @click="$emit('close')">cancel</v-btn>
                <v-btn :loading="saveloading" depressed color="primary" @click="handleSaveMember"
                  >save</v-btn
                >
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex
          v-if="$store.state.privilege && $store.state.privilege.role === 'superadmin'"
          xs12
          sm12
          class="py-3"
        >
          <div class="my-2" style="display: flex">
            <v-btn
              depressed
              color="#fb6d6d"
              class="ma-0 mr-1 mb-1 white--text"
              style="width: 150px"
              :loading="loadingBlock"
              @click="handleBlockMember"
            >
              <em class="fas fa-ban"></em>
              <span v-if="!editdata.is_block" class="pl-2">Block สมาชิก </span>
              <span v-else class="pl-2">Unblock สมาชิก </span>
            </v-btn>
            <v-tooltip v-if="editdata.is_block" right>
              <template #activator="{ on }">
                <v-icon color="grey" v-on="on">error</v-icon>
              </template>
              <span style="font-size: 14px"
                >สมาชิกที่ถูก Unblock จะสามารถกลับมาสะสมคะแนนและแลกของรางวัลได้</span
              >
            </v-tooltip>
            <v-tooltip v-else right>
              <template #activator="{ on }">
                <v-icon color="grey" v-on="on">error</v-icon>
              </template>
              <span style="font-size: 14px"
                >สมาชิกที่ถูก Block จะไม่สามารถสะสมคะแนนและแลกของรางวัลได้</span
              >
            </v-tooltip>
            <div class="ml-3">
              <textarea
                ref="shareLink"
                v-model="block_note"
                class="form-control pa-2"
                style="resize: vertical; min-height: 70px; width: 250px; background: #eee"
                onclick="this.select()"
                placeholder="หมายเหตุ"
              ></textarea>
            </div>
          </div>
          <div>
            <v-btn
              depressed
              color="error"
              class="ma-0 mr-1 mb-1"
              style="width: 150px"
              :loading="loadingDelete"
              @click="handleDeleteMember"
            >
              <v-icon>delete</v-icon>
              <span class="pl-2">ลบสมาชิก </span>
            </v-btn>
            <v-tooltip right>
              <template #activator="{ on }">
                <v-icon color="grey" v-on="on">error</v-icon>
              </template>
              <span style="font-size: 14px"
                >ข้อมูลของสมาชิกทั้งหมดจะถูกลบ เช่น ข้อมูลส่วนตัว ประวัติการสะสมคะแนนและแลกของรางวัล
                หากสมาชิกต้องการกลับมาใช้งานจะต้องสมัครสมาชิกเข้ามาใหม่</span
              >
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
    </template>
    <template v-else-if="currentTab === 'history'">
      <RedeemPointHistory
        v-if="currentTab === 'history' && editdata.id"
        v-model="editdata.id"
      ></RedeemPointHistory>
    </template>
    <template v-else-if="currentTab === 'editLog'">
      <HistoryEditMemberLog
        v-if="currentTab === 'editLog' && editdata.id"
        v-model="editdata.id"
      ></HistoryEditMemberLog>
    </template>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import api from '@/api'
import { mapGetters } from 'vuex'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import PhotoViewer from 'photoviewer'
import uploadfile from '@/components/elements/uploadfile.vue'
import HistoryEditMemberLog from './HistoryEditMemberLog'
import RedeemPointHistory from './RedeemPointHistory'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    DatePickerWithoutButton,
    uploadfile,
    HistoryEditMemberLog,
    RedeemPointHistory,
    Multiselect
  },
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        firstName: '',
        lastName: '',
        dob: '',
        job: '',
        identityNumber: '',
        identityNumberImage: '',
        lineName: '',
        memberId: '',
        tier: '',
        departmentStore: '',
        branch: ''
      },
      member_status: false,
      currentTab: 'info',
      showEditHistory: false,
      loadingBlock: false,
      loadingDelete: false,
      block_note: '',
      jobOptions: [
        'ผู้รับเหมา',
        'ช่างสี',
        'ช่างไม้',
        'ช่างฝ้า',
        'ช่างปูกระเบื้อง',
        'ช่างซ่อมบำรุง/ช่างฝีมือทั่วไป',
        'สถาปนิก / อินทีเรีย /  ดีไซเนอร์',
        'อื่นๆ'
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.$set(this, 'input', {
      firstName: this.editdata.first_name,
      lastName: this.editdata.last_name,
      dob: this.editdata.dob,
      job: this.editdata.job,
      identityNumber: this.editdata.identity_number,
      identityNumberImage: this.editdata.identity_number_image,
      lineName: this.editdata.linename,
      memberId: this.editdata.toa_member_id,
      tier: this.editdata.tier,
      departmentStore: this.editdata.department_store,
      branch: this.editdata.branch
      // member_status: this.editdata.member_status,
    })

    this.block_note = this.editdata.block_note
    this.$nextTick(() => {
      this.member_status = this.editdata.member_status === 'true' ? true : false
    })
    this.$forceUpdate()

    // }
  },
  methods: {
    showImage(item) {
      var items = [
        {
          src: item,
          title: `${item}`
        }
      ]

      // define options (if needed)
      var options = {
        fixedContent: false,
        fixedModalPos: true,
        index: 0 // this option means you will start at first image
      }

      // Initialize the plugin
      var viewer = new PhotoViewer(items, options)
      document.querySelector('.photoviewer-modal').addEventListener(
        'click',
        function (event) {
          //  document.getElementById("output-box").innerHTML += "Sorry! <code>preventDefault()</code> won't let you check this!<br>";
          event.preventDefault()
        },
        false
      )
    },
    getdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    // async savedata() {
    //   if (await this.$validator.validateAll()) {
    //     if (this.edittype == 'create') {
    //       this.createdata()
    //     } else {
    //       this.editbranch()
    //     }
    //   }
    // },
    async handleSaveMember() {
      const vm = this
      try {
        const resultValidate = await this.$validator.validateAll()

        if (!resultValidate) {
          return
        }

        const result = await vm.$swal.fire({
          type: 'warning',
          title: 'ยืนยันการเปลี่ยนแปลงและแก้ไขข้อมูล',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.editmember()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async editmember() {
      try {
        let data = {
          pageid: this.selectedBot.pageid,
          block_note: this.block_note,
          ...this.input
        }

        data.memberId = this.editdata.id

        this.saveloading = true
        api.editmembertoacrm(data, async (err, response) => {
          api.editToacrmMemberStatus(
            {
              data: { member_status: this.member_status ? true : false },
              params: {
                id: this.editdata.id,
                pageid: this.selectedBot.pageid
              }
            },
            (err, response2) => {
              if (response2.responsecode == 200) {
                this.$emit('onsave')
              }
            }
          )
        })
      } catch (error) {
        console.error(error)
        this.saveloading = false
      }
    },
    async handleBlockMember() {
      const vm = this
      const isBlock = vm.editdata.is_block
      const name = vm.editdata.first_name
      try {
        const title = isBlock
          ? `คุณต้องการจะ Unblock ${name} ใช่หรือไม่ ?`
          : `คุณต้องการจะ Block ${name} ใช่หรือไม่ ?`
        let result = await vm.$swal.fire({
          title: title,
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true,
          showCancelButton: true
        })

        if (result.value) {
          const data = {
            pageId: vm.selectedBot.pageid,
            memberId: vm.editdata.id
          }

          let response = null
          vm.loadingBlock = true
          if (isBlock) {
            response = await vm.unblockMember(data)
          } else {
            Object.assign(data, {
              blockNote: {
                block_note: vm.block_note
              }
            })
            response = await vm.blockMember(data)
          }
          vm.loadingBlock = false

          if (response && response.status === 200) {
            vm.$swal.fire({
              title: this.$t('Successfully'),
              type: 'success'
            })
            vm.$emit('onsave')
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async blockMember(data) {
      try {
        const response = await toaCrmApi.blockMember({ config: data })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async unblockMember(data) {
      try {
        const response = await toaCrmApi.unblockMember({ config: data })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleDeleteMember() {
      const vm = this
      try {
        const name = vm.editdata.first_name
        let result = await vm.$swal.fire({
          title: `คุณต้องการลบ ${name} ใช่หรือไม่ ?`,
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true,
          showCancelButton: true
        })

        if (result.value) {
          const data = {
            pageId: vm.selectedBot.pageid,
            memberId: vm.editdata.id
          }

          vm.loadingDelete = true
          let response = await vm.deleteMember(data)
          vm.loadingDelete = false

          if (response && response.status === 200) {
            vm.$swal.fire({
              title: this.$t('Successfully'),
              type: 'success'
            })
            vm.$emit('onsave')
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteMember(data) {
      try {
        const response = await toaCrmApi.deleteMember({ config: data })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/MemberEdit.vue